var utils = require('./index')
var pluralize = require('./pluralize')

var utilsMap = {
  '%s': function (str) {
    return str
  },
  '%d': utils.number,
  '%f': utils.number,
  '%m': utils.currency,
  '%h': utils.phone,
  '%t': utils.datetime,
  '%p': pluralize,
}

function getArgs(str) {
  var matches = str.match(/^{(%\w),\s*(\w+),?\s?(.+)?}$/)
  if (!matches) return []
  return matches.slice(1).filter(Boolean)
}

function findPhrases(str, data, locals) {
  return str.replace(/({%p,.+}}|{%\w,[\w,\s:;]+})/gm, function (match, p1) {
    var args = getArgs(p1)
    var dynamicValue = Array.isArray(data) ? data[+args[1]] : data[args[1]]
    // make sure to replace dynamic phrases inside plural blocks
    // before trying to pluralize
    if (args[0] === '%p') {
      args[2] = findPhrases(args[2], data, locals)
    }
    return utilsMap[args[0]].call(null, dynamicValue, args[2], locals)
  })
}

function dynamicPhrases(str, data, locals) {
  return findPhrases(str, data, locals)
}

module.exports = {
  format: dynamicPhrases,
  findPhrases: findPhrases,
  getArgs: getArgs,
}
